import { render, staticRenderFns } from "./AgeGateModal.vue?vue&type=template&id=3cb351f4&scoped=true&"
import script from "./AgeGateModal.vue?vue&type=script&lang=js&"
export * from "./AgeGateModal.vue?vue&type=script&lang=js&"
import style0 from "./AgeGateModal.vue?vue&type=style&index=0&id=3cb351f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb351f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardTitle,VImg})
